import { exportExcel } from "@api/stores/salesInvoiceReport/exportExcel/path";
import { exportPDF } from "@api/stores/salesInvoiceReport/exportPDF/path";
import { exportSinglePDF } from "@api/stores/salesInvoiceReport/exportSinglePDF/path";
import { stats } from "@api/stores/salesInvoiceReport/stats/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/sales-invoice-reports/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const salesInvoiceReport = {
  getAll: apiPathFunc(pathBase),
  stats,
  exportPDF,
  exportExcel,
  exportSinglePDF,
};
